import RowStack from '../container/RowStack'
import { Button, IconButton } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import colors from 'styles/colors'

const AcceptRejectButtons = ({
  acceptLabel,
  onAccept,
  onReject,
  acceptButtonProps={},
  background = colors.White
}) => {
  return (
    <RowStack width='unset' spacing={0}>
      <Button size='small' onClick={() => onAccept()} {...acceptButtonProps}>
        {acceptLabel}
      </Button>
      {onReject && (
        <IconButton
          onClick={() => onReject()}>
          <CancelOutlinedIcon
            fontSize='large'
            sx={{ strokeWidth: 1, stroke: background }}
          />
        </IconButton>
      )}
    </RowStack>
  )
}

export default AcceptRejectButtons
